module.exports = __webpack_public_path__ + "static/media/18ECA34.883aa0d6.jpg";